import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import App from './App'
import {injectResetStoreAction} from './services'
import utils from './utils'

/* STORE: 
========================== */
import store_redux, {resetStore} from './store_redux'

injectResetStoreAction(resetStore)

ReactDOM.render(
  <Provider store={store_redux}>
    <App />
  </Provider>,
  document.getElementById('root'),
)

// Reomve All the expired token
utils.removeExpiryToken()
